import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { filter, tap } from 'rxjs/operators';
import { HelpMenuItem, HelpMenuItemId, LabelItem, UserDocsUrls } from '../+state/system/models';
import { AppConfigJsonModel } from '../models/app-config-models';

export function configProvider(configService: ConfigService) {
  return () => configService.load();
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  httpClient = inject(HttpClient);
  // PATH ON SERVER
  private readonly configUrl = 'assets/config.json';
  config: AppConfigJsonModel;
  externalApiHost: string;
  userDocsUrls: HelpMenuItem[];

  load() {
    return this.httpClient.get<AppConfigJsonModel>(this.configUrl).pipe(
      tap(result => {
        this.config = result;
      }),
      filter(config => Boolean(config['user-docs-urls'])),
      tap((config: { externalApiHost: string; 'user-docs-urls': UserDocsUrls }) => {
        this.userDocsUrls = this.mapToHelpMenuItem(config['user-docs-urls']);
      }),
    );
  }

  private mapToHelpMenuItem(urls: UserDocsUrls): HelpMenuItem[] {
    return Object.values(HelpMenuItemId).map(id => ({
      id,
      link: urls[id],
      label: LabelItem[id],
    }));
  }
}
